import Vue from "vue";
import Vuetify from "vuetify/lib/framework";

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: "md",
  },
  theme: {
    themes: {
      light: {
        primary: "#284E3C",
        secondary: "#D6AC5C",
        accent: "#D6AC5C",
      },
      dark: {
        primary: "#284E3C",
        secondary: "#D6AC5C",
        accent: "#D6AC5C",
      },
    },
  },
});
